import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';

import { ProvisionComparison } from '../../../objects/provision-analysis';

/**
 * The Document Review table: one row per approved provision, showing how the
 * analyzed document covers it.
 *
 * Extracted from the AI analysis dialog's "Analysis" tab so the workflow request's
 * Document Review renders the identical thing. Two hand-maintained copies of this
 * table would drift in exactly the way that matters least visibly and most:
 * a risk chip that means one thing on one screen and another elsewhere.
 *
 * Presentation only — running, persisting and error-handling the analysis stay with
 * the host, because those differ (a contract writes onto the contract, a workflow
 * request writes onto the request).
 */
@Component({
  selector: 'app-provision-review-table',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatChipsModule],
  templateUrl: './provision-review-table.component.html',
  styleUrls: ['./provision-review-table.component.css']
})
export class ProvisionReviewTableComponent {
  @Input({ required: true }) comparisons: ProvisionComparison[] = [];

  /** Risk chip class for the lowercase risk values (low|medium|high). */
  riskClass(score: string): string {
    switch ((score || '').toLowerCase()) {
      case 'high': return 'risk-high';
      case 'medium': return 'risk-medium';
      case 'low': return 'risk-low';
      default: return '';
    }
  }
}
